<template>
  <header>
    <page-link class="logo" href="/">
      <img alt="A Wass Funeral Directors" src="../assets/logo.jpg" />
    </page-link>
    <div class="contacts">
      <a
        :href="'tel:' + settings.branches[0].telephone"
        class="contacticon"
        v-if="settings && settings.branches && settings.branches.length && settings.branches[0].telephone"
      >
        <i class="fa fa-phone"></i>
        <span>{{settings.branches[0].telephone}}</span>
      </a>
      <a
        :href="'mailto:' + settings.branches[0].email"
        class="contacticon"
        v-if="settings && settings.branches && settings.branches.length && settings.branches[0].email"
      >
        <i class="fa fa-envelope"></i>
        <span>{{settings.branches[0].email}}</span>
      </a>
      <a
        :href="settings.twitter"
        aria-label="Twitter"
        class="social"
        rel="noreferrer"
        target="_blank"
        v-if="settings && settings.twitter"
      >
        <i class="fa fa-twitter"></i>
      </a>
      <a
        :href="settings.facebook"
        aria-label="Facebook"
        class="social"
        target="_blank"
        rel="noreferrer"
        v-if="settings && settings.facebook"
      >
        <i class="fa fa-facebook"></i>
      </a>
      <a
        :href="settings.google"
        aria-label="Google"
        class="social"
        rel="noreferrer"
        target="_blank"
        v-if="settings && settings.google"
      >
        <i class="fa fa-google"></i>
      </a>
    </div>
    <a
      @click.prevent="showMenu = !showMenu"
      aria-label="Menu"
      class="mobile-menu"
      href
      id="mobile-menu-btn"
    >
      <i class="fa fa-bars" v-show="!showMenu"></i>
      <i class="fa fa-times" v-show="showMenu"></i>
    </a>
    <nav :class="{open: showMenu}">
      <ul>
        <li
          :class="menu_page.ItemID == 'UrFA9T-Bd' ? 'privacy' : ''"
          :key="menu_page.itemID"
          v-for="menu_page in main_pages"
        >
          <page-link :href="menu_page.url || '/'">
            {{menu_page.name}}
            <span
              @click.prevent="toggleSubMenu($event)"
              class="down"
              v-if="menu_page.subs && menu_page.subs.length"
            >
              <i class="fa fa-chevron-down"></i>
              <i class="fa fa-chevron-up"></i>
            </span>
          </page-link>
          <ul v-if="menu_page.subs && menu_page.subs.length">
            <li :key="sub_page.ItemID" v-for="sub_page in menu_page.subs">
              <page-link :href="sub_page.url">{{sub_page.name}}</page-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "Header",
  data: function() {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapState(["settings", "main_pages"])
  },
  methods: {
    toggleSubMenu: event => {
      var li = event.srcElement.closest("li")
      li.classList.toggle("open")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  padding: 3rem 3%;
  position: relative;
  background: #231f20;
}

.logo img {
  width: 40rem;
}

nav {
  position: absolute;
  right: 3%;
  bottom: 2rem;
}

.contacts {
  float: right;
}

.contacts a {
  margin-right: 3rem;
  color: rgba(245, 245, 245, 0.6);
}

.contacts a.social {
  margin-right: 1.5rem;
}

.contacts a:last-child {
  margin-right: 0;
}

.contacts i {
  color: #bb9765;
  margin-right: 0.5rem;
}

.contacts a.social i {
  margin-right: 0;
  font-size: 2rem;
}

i.fa-twitter {
  color: #229ff1;
}

i.fa-facebook {
  color: #4467b0;
}

i.fa-google {
  color: #ff4031;
}

i.fa-linkedin {
  color: #0973b1;
}

nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
  z-index: 100;
  text-align: center;
}

nav ul li {
  display: inline-block;
  text-align: left;
}

nav ul li.sel {
  color: #bb9765;
}

nav a {
  display: block;
  padding: 0 2rem;
  color: #fff;
  font-size: 1.5rem;
  text-decoration: none;
  line-height: 4rem;
  text-transform: uppercase;
}

/* Hide Dropdowns by Default */
nav ul ul {
  display: none;
  position: absolute;
  top: 4rem; /* the height of the main nav */
}

/* Fisrt Tier Dropdown */
nav ul ul li {
  width: auto;
  float: none;
  display: list-item;
  position: relative;
}

nav ul ul li a {
  line-height: 4rem;
}

/* Second, Third and more Tiers	*/
nav ul ul ul li {
  position: relative;
  top: 7rem;
  left: 0;
}
nav .down {
  padding: 0rem 0.5rem;
  opacity: 0.3;
  position: relative;
}

nav .down .fa-chevron-up {
  display: none;
}

.mobile-menu {
  display: none;
  position: absolute;
  top: -0.7rem;
  left: 3%;
  font-size: 4.5rem;
  color: #bb9765;
}

.mobile-menu > * {
  position: absolute;
  left: 0;
  top: 2.4rem;
  transition: all 0.2s;
}

.mobile-menu .fa-times {
  margin-left: 0.5rem;
}

.privacy {
  display: none !important;
}

@media screen and (max-width: 1550px) {
  .logo img {
    width: 30rem;
  }
  nav {
    bottom: 1rem;
  }
  nav a {
    padding: 1rem;
  }
}

@media screen and (min-width: 1051px) {
  header {
    min-height: 16rem;
  }
  /* Display Dropdowns on Hover */
  nav ul li:hover > ul {
    display: inherit;
  }
  nav ul li:hover > a {
    color: #bb9765;
  }

  nav ul li:hover a {
    background: #231f20;
  }
}

@media screen and (max-width: 1050px) {
  .logo {
    left: 8rem;
    position: relative;
  }
  header {
    height: 90px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }
  nav {
    position: fixed;
    top: 90px;
    right: 100%;
    width: 100%;
    transition: all 0.3s;
    z-index: 9999;
    min-height: calc(100vh - 90px);
    background: #bb9765;
  }
  nav .down {
    padding: 0.8rem 1rem;
    padding-left: 1.5rem;
    top: -0.8rem;
    right: -1rem;
    position: relative;
    opacity: 1;
  }

  nav .down {
    display: block;
    float: right;
  }
  nav.open {
    right: 0;
  }
  nav ul {
    padding-bottom: 2rem;
    background: #bb9765;
  }
  nav ul a {
    padding: 1.5rem 2rem;
    line-height: 1.2;
    font-size: 2rem;
    color: white;
    background: #bb9765;
  }
  nav ul a:hover {
    background: #bb9765;
  }
  nav ul ul li a {
    line-height: 1.2;
  }
  nav ul li {
    display: block;
    background: #bb9765;
  }
  nav ul ul {
    position: relative;
    top: 0;
    left: 2rem;
    width: calc(100% - 4rem);
    padding-bottom: 1rem;
  }
  nav ul li.open ul {
    display: block;
  }

  nav li.open .down .fa-chevron-up {
    display: block;
  }

  nav li.open .down .fa-chevron-down {
    display: none;
  }

  .search {
    float: none;
    margin-bottom: 2rem;
  }
  .search-input {
    width: 90%;
  }
  .search-button {
    float: right;
  }
  .mobile-menu {
    display: block;
    top: 1rem;
  }
}

@media screen and (max-width: 800px) {
  .contacts a {
    margin-right: 1rem;
    margin-left: 1rem;
  }
  .contacticon {
    font-size: 3rem;
  }
  .contacticon span {
    display: none;
  }
  .social {
    display: none;
  }
  .logo {
    top: 1rem;
    left: 6rem;
  }
  .logo img {
    width: 20rem;
  }
}

@media screen and (max-width: 450px) {
  .contacticon:nth-child(2) {
    display: none;
  }
}
</style>
